import { SortDescriptor } from "react-aria-components";

import { API_KEY_ROLES_COLUMN_ID } from "../constants";
import { ApiKeyViewRoleBinding } from "../../types";

export const sortRoles = (items: ApiKeyViewRoleBinding[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string;
    let valueB: string;

    switch (sortDescriptor.column as API_KEY_ROLES_COLUMN_ID) {
      case API_KEY_ROLES_COLUMN_ID.NAME:
        valueA = a.role.name;
        valueB = b.role.name;
        break;
      case API_KEY_ROLES_COLUMN_ID.GRANTED_AT:
        valueA = a.space.name;
        valueB = b.space.name;
        break;
      case API_KEY_ROLES_COLUMN_ID.DESCRIPTION:
      case API_KEY_ROLES_COLUMN_ID.DROPDOWN:
        // These columns are not sortable, but include for exhaustiveness
        return 0;
      default:
        return 0;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
